import { useState, useEffect } from "react";
import { Button, Box, TextField } from "@mui/material";
import { UseSupplierRequest } from "./UseSupplierRequest";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import SuppliersList from "./SuppliersList";

export default function EditRequest() {
  const { isSmall } = useBreakpoints();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [request, setRequest] = useState();
  const { getRequestByID, validate, updateRequest } = UseSupplierRequest();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [expireDate, setExpireDate] = useState();
  const { toSolar } = require("jdate-convert");
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const [state, setState] = useState({
    id: undefined,
    productID: undefined,
    expiredate: undefined,
    product: undefined,
    requestCount: undefined,
    suppliers: [],
  });

  const [errorState, setErrorState] = useState({
    productID: false,
    expiredate: false,
    requestCount: false,
  });

  useEffect(() => {
    if (location.state.id) {
      setProgress(true);
      getRequestByID(location.state.id, (supplierRes) => {
        setState({
          id: supplierRes.id,
          productID: supplierRes.productID,
          operator: supplierRes.operator,
          product: supplierRes.product,
          expiredate: supplierRes.expiredate?.split("T")[0],
          requestCount: supplierRes.requestCount,
          suppliers: supplierRes.suppliers,
        });
      });
    }
  }, []);

  useEffect(() => {
    let newValueEnd = expireDate?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    setState({ ...state, expiredate: newValueEnd });
  }, [expireDate]);

  return (
    <Detail
      breadChilds={{
        title: "بازرگانی",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/supplierrequest" },
          { name: "ویرایش درخواست", url: "/supplierrequest/editRequest" },
        ],
      }}
    >
      {!request ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 7"}>
            <TextField
              fullWidth
              id="filled-basic"
              value={state.product ? state.product : ""}
              label="محصول"
              variant="filled"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="filled-basic"
              value={state.operator ? state.operator : ""}
              label="اپراتور"
              variant="filled"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}

          <Box
            gridColumn={isSmall ? "span 12" : "span 2"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <DatePicker
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              value={state && state.expiredate ? toSolar(state.expiredate) : ""}
              onChange={setExpireDate}
              render={
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  label="مهلت ارائه پیشنهاد"
                  size="small"
                  fullWidth
                />
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 2"}>
            <TextField
              fullWidth
              value={state.requestCount ? state.requestCount : ""}
              error={errorState.requestCount}
              label="تعداد درخواست"
              size="small"
              variant="filled"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: { direction: "rtl" },
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 10"></Box>}
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            gridColumn="span 12"
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  updateRequest(state, () => {
                    navigate("/supplierrequest", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/supplierrequest", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
          <Box gridColumn="span 12">
            <SuppliersList
              callback={(requestID) => {
                setProgress(true);
                getRequestByID(requestID, (supplierRes) => {
                  setState({
                    id: supplierRes.id,
                    productID: supplierRes.productID,
                    operator: supplierRes.operator,
                    product: supplierRes.product,
                    expiredate: supplierRes.expiredate?.split("T")[0],
                    requestCount: supplierRes.requestCount,
                    suppliers: supplierRes.suppliers,
                  });
                });
              }}
              items={state.suppliers}
              requestID={state.id ? state.id : ""}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 10"></Box>}
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
